/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientSessionItemDto = {
    /**
     * Session UUID
     */
    id: string;
    /**
     * Session number in the booking
     */
    sessionNumber: number;
    /**
     * Scheduled start time
     */
    scheduledStartTime: string;
    /**
     * Scheduled end time
     */
    scheduledEndTime: string;
    /**
     * Session status
     */
    status: ClientSessionItemDto.status | null;
    /**
     * Session mode
     */
    mode?: ClientSessionItemDto.mode | null;
    /**
     * Attendance status
     */
    attendanceStatus?: ClientSessionItemDto.attendanceStatus | null;
    /**
     * Client phone country code
     */
    phoneCountryCode?: string | null;
    /**
     * Client phone number
     */
    phoneNumber?: string | null;
    /**
     * Booking UUID
     */
    bookingId: string;
    /**
     * Booking type
     */
    bookingType: ClientSessionItemDto.bookingType;
    /**
     * Booking status
     */
    bookingStatus?: ClientSessionItemDto.bookingStatus | null;
    /**
     * Booking creation date
     */
    bookingCreatedAt?: Record<string, any> | null;
    /**
     * Package name
     */
    packageName?: string | null;
    /**
     * Total sessions in the package
     */
    totalPackageSessions?: number | null;
};
export namespace ClientSessionItemDto {
    /**
     * Session status
     */
    export enum status {
        SCHEDULED = 'scheduled',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        RESCHEDULED = 'rescheduled',
    }
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        IN_PERSON = 'in_person',
    }
    /**
     * Attendance status
     */
    export enum attendanceStatus {
        PENDING = 'pending',
        MARKED = 'marked',
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
    }
    /**
     * Booking type
     */
    export enum bookingType {
        PACKAGE = 'package',
        SINGLE_SESSION = 'single_session',
    }
    /**
     * Booking status
     */
    export enum bookingStatus {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
}

